module.exports = __webpack_public_path__ + "bcd4026782821fa18f54796276b92711.pdf";